import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';

/** Returns the API-provided blob SAS URL for the browser PUT. */
export function resolveBlobUploadUrl(uploadUrl: string): string {
  return uploadUrl;
}

/** Resolves the URL used for the blob PUT from the API-provided SAS URL. */
export async function resolveBlobPutUrl(
  _entityId: string,
  _fileName: string,
  apiUploadUrl?: string,
  _useProvidedUploadUrl = false
): Promise<string> {
  return apiUploadUrl?.trim() ?? '';
}

export function createBlobPutHeaders(): HttpHeaders {
  return new HttpHeaders({
    'x-ms-blob-type': 'BlockBlob',
  });
}

/** PUTs the file to blob storage, reporting bytes sent as the browser uploads it. */
export function putBlobWithProgress(
  http: HttpClient,
  putUrl: string,
  file: File,
  onProgress: (loadedBytes: number) => void
): Observable<unknown> {
  return http
    .put(putUrl, file, {
      headers: createBlobPutHeaders(),
      responseType: 'text',
      observe: 'events',
      reportProgress: true,
    })
    .pipe(
      tap((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          onProgress(event.loaded);
        }
      }),
      filter((event) => event.type === HttpEventType.Response)
    );
}

function isExpectedProcessedUploadFailure(error: unknown, uploadSucceeded: boolean): boolean {
  if (uploadSucceeded || error == null || typeof error !== 'object') {
    return false;
  }

  return (error as { status?: number }).status === 400;
}

/** After a blob PUT attempt, notify the API to record upload outcome and start processing when applicable. */
export function completeBlobUploadAfterPut(
  http: HttpClient,
  apiUrl: string,
  uploadSucceeded: boolean,
  processedEndpoint: 'processedDrawings' | 'ProcessedCaptures',
  body: Record<string, string | number>
): Observable<void> {
  return http.post(`${apiUrl}/${processedEndpoint}`, body).pipe(
    catchError((error) =>
      isExpectedProcessedUploadFailure(error, uploadSucceeded) ? of(undefined) : throwError(() => error)
    ),
    map(() => undefined)
  );
}
